/*
 * @Author: your name
 * @Date: 2022-03-30 16:41:29
 * @LastEditTime: 2022-03-30 17:18:30
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xingmahui_front\src\utils\mockData\noBabyArticleList.js
 */
export default {
  articleList: [
    {
      id: "1",
      text: "孕前应该做的9件事和不应该做的5件事。应该做的有：看牙医、补充叶酸、保持运动、查看存款……",
      prodId: "24025",
      uatId: "11477",
    },
    {
      id: "2",
      text: "判断怀孕，你用对方法了吗？多久可以用早孕试纸？多久可以血检？如果有这4个症状，也可能预示你怀孕了",
      prodId: "24179",
      uatId: "5521",
    },
    {
      id: "3",
      text: "老公备孕期间要做哪些检查？一张表即可看明白，可以根据具体情况酌情检查哦~不清楚的，来点击保存吧",
      prodId: "23966",
      uatId: "6923",
    },
    {
      id: "4",
      text: "体重会影响怀孕吗？多少体重最适合备孕？偏瘦和偏胖的备孕女性该怎么吃？专家告诉你答案，点击了解",
      prodId: "24032",
      uatId: "6924",
    },
    {
      id: "5",
      text: "憋得越久，小蝌蚪越优质？只有排卵期同房，才能受孕？排卵期频繁同房具一定能怀？真正的答案在这里",
      prodId: "24182",
      uatId: "6925",
    },
    {
      id: "6",
      text: "6个最容易让女性衰老的习惯，包括不重视防晒、喝水太少、吃盐过多、过度减肥……",
      prodId: "24333",
      uatId: "6926",
    },
    {
      id: "7",
      text: "测不出早孕，可能是你踩了一些雷区！测孕时间、测孕方法大有讲究哦～快来听听专家怎么说",
      prodId: "24288",
      uatId: "6928",
    },
    {
      id: "8",
      text: "你是“寒性”体质吗？5个信号，帮助你判断！寒性体质备孕需要注意什么？快来听听专家怎么说",
      prodId: "24029",
      uatId: "6922",
    },
    {
      id: "9",
      text: "补充叶酸，到底是选纯叶酸片还是复合维生素？准爸爸到底要不要补？什么时候开始补？答案看这里",
      prodId: "24030",
      uatId: "11399",
    },
    {
      id: "10",
      text: "这7类人群最好去做孕前检查，包括未做过婚检、有遗传病史、女方年龄大于30岁、有不良产史",
      prodId: "24396",
      uatId: "5388",
    },
  ],
};
